// This function allow to reference chunks
__webpack_require__.miniCssF = function(chunkId) {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "css/" + chunkId + "-" + {321: "baaf9115",43: "ef46db37",696: "6b9b0cbd",}[chunkId] + ".css"
}